<template>
  <div>
    <v-card>
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title>
          {{ $t('titles.global.pendingUsers') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon dark :loading="localLoading" @click="init">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>
      <v-toolbar card flat dense color="white">
        <filters @search="search(true)" />

        <v-text-field
          v-model="localFilters.match"
          flat
          hide-details
          :placeholder="$t('action.buttons.search')"
          prepend-icon="search"
          solo
          @input="search(true)"
        />
      </v-toolbar>
      <v-divider />
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="pendingUsers"
          disable-initial-sort
          :loading="loading || localLoading"
          :total-items="localPagination.totalItems"
          :pagination.sync="localPagination"
          :rows-per-page-items="[5, 10]"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-chip small color="transparent">
                <v-avatar v-if="props.item.photo" size="32">
                  <img :src="props.item.photo" alt />
                </v-avatar>
                {{ props.item.name }}
              </v-chip>
            </td>
            <td>{{ props.item.role }}</td>
            <td>
              <template v-if="props.item.objects">
                <template v-for="(object, index) of props.item.objects">
                  <template v-if="props.item.typeRole == 'familiar'">
                    <v-list-tile :key="object._id + index" avatar ripple>
                      <v-list-tile-avatar v-if="object.img" size="32">
                        <img :src="object.img" />
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="object.name" />
                      </v-list-tile-content>
                      <v-list-tile-action v-if="props.item.teams">
                        <template v-for="(team, index2) of props.item.teams">
                          <v-list-tile
                            :key="team._id + index + index2"
                            avatar
                            ripple
                          >
                            <v-list-tile-avatar v-if="team.logo" size="32">
                              <img :src="team.logo" />
                            </v-list-tile-avatar>
                            <v-list-tile-content class="caption">
                              <v-list-tile-title>
                                <span> {{ team.name }}</span>
                              </v-list-tile-title>
                              <v-list-tile-sub-title
                                class="caption primary--text text--lighten-1 text-truncate text-no-wrap"
                              >
                                {{ team.categoryName.join(' - ') }}
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                  <template v-else>
                    <v-list-tile :key="object._id" avatar ripple>
                      <v-list-tile-avatar v-if="object.img" size="32">
                        <img :src="object.img" />
                      </v-list-tile-avatar>
                      <v-list-tile-content class="caption">
                        <v-list-tile-title>
                          <span> {{ object.name }}</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title
                          v-if="object.categoryName"
                          class="caption primary--text text--lighten-1 text-truncate text-no-wrap"
                        >
                          {{ object.categoryName.join(' - ') }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </template>
              </template>
            </td>
            <td class="text-xs-center">
              {{ formatDate(props.item.createdAt) }}
            </td>
            <td class="text-xs-center">
              <template v-if="indexLoading === props.index">
                <v-progress-circular :size="20" indeterminate color="primary" />
              </template>
              <template v-else-if="canConfirm(props.item)">
                <button-confirm
                  color="primary"
                  small
                  flat
                  icon="check"
                  :text="$t('action.buttons.confirmRole')"
                  @submit="_enrole(props.item, props.index)"
                />
                <button-confirm
                  color="error"
                  small
                  flat
                  icon="close"
                  :text="$t('action.buttons.rejectRole')"
                  @submit="_enrole(props.item, props.index, true)"
                />
              </template>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { debounce } from 'debounce'
import { mapActions, mapState } from 'vuex'
import Filters from './PendingUsersFilters'
import { formatDate } from '@/helpers/dateHelper'
export default {
  name: 'PendingUsers',
  components: { Filters },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      indexLoading: '',
      localLoading: false,
    }
  },
  watch: {
    'localPagination.page': {
      handler: function () {
        this.search()
      },
    },
    'localPagination.rowsPerPage': {
      handler: function () {
        this.search()
      },
    },
  },
  computed: {
    ...mapState({
      roles: (state) => state.auth.roles,
      filters: (state) => state.stats.pendingUsers.filters,
      pagination: (state) => state.stats.pendingUsers.pagination,
    }),
    pendingUsers() {
      return this.items.map((item) => ({
        ...item,
        text: item.objects
          ? item.objects.map((object) => object.name).join(', ')
          : '',
      }))
    },
    headers() {
      return [
        {
          text: this.$tc('models.user'),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$tc('models.role'),
          value: 'role',
          sortable: false,
        },
        {
          text: `${this.$tc('models.entity')} / ${this.$tc(
            'models.team'
          )} / ${this.$tc('titles.global.player')} / ${this.$tc(
            'models.tournament'
          )} `,
          value: 'text',
          sortable: false,
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
          sortable: false,
        },
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('stats/setPendingUsersPagination', value)
      },
    },
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('stats/setPendingUsersFilters', value)
      },
    },
  },
  methods: {
    ...mapActions({
      enrole: 'users/enrole',
      fetchPendingUsers: 'stats/fetchPendingUsers',
    }),
    init() {
      this.localLoading = true
      this.fetchPendingUsers().finally(() => {
        this.localLoading = false
      })
    },
    search: debounce(function (resetPage) {
      if (resetPage && this.localPagination.page !== 1) {
        this.localPagination.page = 1
      }
      this.init()
    }, 1000),
    _enrole(userRole, index, unrole = false) {
      this.indexLoading = index
      let payload = {
        userId: userRole._id,
        userRoleId: userRole.userRoleId,
        unrole,
        view: 'home',
      }
      this.enrole(payload).finally(() => {
        this.indexLoading = ''
      })
    },
    canConfirm(item) {
      let canConfirm = this.roles.some(
        (role) =>
          role.confirm &&
          role.roleId &&
          ['all', 'president', 'coordinator'].includes(role.roleId.type)
      )

      if (canConfirm) return true
      let trainerRole = this.roles.find(
        (role) => role.confirm && role.roleId && role.roleId.type === 'trainer'
      )
      if (trainerRole) {
        if (item.typeRole === 'player') {
          canConfirm = trainerRole.objectId.some((teamId) =>
            item.objectId.includes(teamId)
          )
        } else if (item.typeRole === 'familiar') {
          canConfirm = trainerRole.objectId.some(
            (teamId) => item.teams && item.teams.includes(teamId)
          )
        }
      }
      return canConfirm
    },
    formatDate(date) {
      return date ? formatDate(date, true) : '--'
    },
  },
}
</script>
